import React, { useEffect } from "react";
import label from "../../labels/accessRightsManagement_en.json";

const AuthorityMaster = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="dashboardContentArea">
      <h5> {label.AuthorityMaster} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default AuthorityMaster;
